// polyfills help supporting older browsers like IE, iOS<9 etc
import "../polyfills";

import importRetry from "../importRetry";

// Rollbar
["production", "staging"].includes(process.env.RAILS_ENV) &&
  importRetry(() => import("../vendor/rollbar"));

// Microsoft Clarity
["production", "staging"].includes(process.env.RAILS_ENV) &&
  importRetry(() => import("../vendor/clarity"));

// Google Analytics
process.env.RAILS_ENV === "production" &&
  importRetry(() => import("../vendor/google/analytics/checkout"));

// Google Fonts
["production", "staging"].includes(process.env.RAILS_ENV) &&
  importRetry(() => import("../vendor/google/fonts/inter"));

["production", "staging"].includes(process.env.RAILS_ENV) &&
  importRetry(() => import("../vendor/google/fonts/source_sans_pro"));

// Cookie consent
["production", "staging"].includes(process.env.RAILS_ENV) &&
  importRetry(() => import("../vendor/cookieconsent"));

// Bootstrap (V5) — loaded via vite_stylesheet_tag in layout

import "../checkout_application_v3";